import { render, staticRenderFns } from "./ImagemDeTabela.vue?vue&type=template&id=7ae27d99&scoped=true&"
import script from "./ImagemDeTabela.vue?vue&type=script&lang=ts&"
export * from "./ImagemDeTabela.vue?vue&type=script&lang=ts&"
import style0 from "./ImagemDeTabela.vue?vue&type=style&index=0&id=7ae27d99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae27d99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
